import { SimulationDateString } from './types';

export const extractRawDateYear = (dateStr: SimulationDateString): number =>
    parseInt(dateStr.substring(0, 4), 10);

// Display date to the following format : DD/MM/YYYY
export const formatSimulationDateString = (
    dateStr: SimulationDateString,
): string => {
    const parts = dateStr.split('-');
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
};
export const extractRawDateMonth = (dateStr: SimulationDateString): number =>
    parseInt(dateStr.substring(5, 7), 10);
